module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/249-democratic-republic-of-congo-16c8dab94b5d39386f283a0374443411.svg";